/**
 * Single source for the auth flags scattered across localStorage.
 *
 * Keys in use: userId, role, isAdmin, isOverAllAdmin.
 * The admin formula mirrors TodoTaskManagement.js and AddTodoTaskModal.js —
 * it lived inline in both, so a change had to be made twice.
 *
 * NOTE: TaskDetails.js derives the user id from the JWT (`decoded.id`) rather
 * than localStorage, so components should accept a `currentUserId` prop that
 * overrides this.
 */
export const getCurrentUser = () => {
  const isOverAllAdmin = localStorage.getItem("isOverAllAdmin") === "true";
  const isAdminFlag = localStorage.getItem("isAdmin") === "true";
  const role = localStorage.getItem("role") || "";
  return {
    userId: localStorage.getItem("userId") || null,
    role,
    isAdmin: isOverAllAdmin || isAdminFlag || role.toUpperCase() === "FEEDBACK-ADMIN",
  };
};

export default getCurrentUser;
